import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import CourseHeader from './CourseHeader';
import CourseInfo from './CourseInfo';
import CourseLesson from './CourseLesson';
import { Card } from 'antd';



class CourseShell extends Component {

  componentDidMount() {
    const {poet, poem, id} = this.props.match.params;

    //add body style
    this.body = document.querySelector('body');
    if (this.body.classList)
      this.body.classList.add('course-body');

    this.headerHeight = document.getElementById('CourseHeader').clientHeight;

    //three database queries: course data, user data, user entry data
    this.props.requestCourseData(poem, id);
    this.props.requestEntries(poem);
    this.props.requestCompletions({poet, poem, id});
    this.props.fetchUser();

    window.addEventListener("resize", () => this.props.resizeWindow(window.innerWidth, window.innerHeight));
  }

  componentWillUnmount() {
    this.props.unmountPoem();

    if (this.body.classList)
      this.body.classList.remove('course-body');

    window.removeEventListener("resize", () => this.props.resizeWindow(window.innerWidth, window.innerHeight));
  }


  calculateHeight() {
    if(this.headerHeight)
      return window.innerHeight - this.headerHeight;
  }

  onScroll(){
    const scrollTop = this.courseInner.scrollTop;
    this.props.setCourseScroll(scrollTop);
  }

  render() {
    return (
      <div id="CourseShell">
        <CourseHeader
          course = {this.props.course}
          logOut = {this.props.logOut}
          changeLesson = {this.props.changeLesson}
        />

        <section id="info" style={{height: this.calculateHeight()}}>
          <Card id="info-inner" hoverable={true}>
            <CourseInfo />
          </Card>
        </section>

        <section id="course" style={{height: this.calculateHeight()}}>
          <div
            id="course-inner"
            onScroll = {() => this.onScroll()}
            ref = {(courseInner) => {this.courseInner = courseInner}}
          >
            <CourseLesson minHeight={this.calculateHeight()} componentData = {this.props.componentData}/>
          </div>
        </section>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    course: state.course,
    componentData: state.course.lesson.componentData
  };
}

export default connect(mapStateToProps, actions)(CourseShell);



// WEBPACK FOOTER //
// ./src/components/Course/CourseShell.js